export const DEFAULT_ITEMS_PER_PAGE = 10;
export const DEFAULT_PAGE_NUMBER = 1;
export const OFFSET_FROM_END = 5;
